<template>
  <button class="forgot-password-btn" type="button" @click="handlerOpenModal">
    {{ messages?.forgetPassword }}
  </button>
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { computed } from 'vue';
import useModal from '@use/useModal/useModal';
import ForgotPassword from '@components/Cabinet/Entry/ForgotPassword/ForgotPassword.vue';

const { state } = useStore();

const modal = useModal();

const messages = computed(() => state.results?.messages?.entry);

const handlerOpenModal = () => {
  modal.show(
    ForgotPassword,
    {},
    {
      width: '900px',
      backgroundClose: false,
    }
  );
};
</script>

<style lang="scss" scoped>
.forgot-password-btn {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  margin-bottom: 4px;
  color: #885e46;
  text-align: left;
}
</style>
